var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7017 24.75H18.2017M22.7017 33.75H18.2017M36.2017 15.75H18.2017M45.2017 15.3V38.7C45.2017 42.4804 45.2017 44.3705 44.466 45.8144C43.8188 47.0845 42.7862 48.1171 41.5161 48.7643C40.0722 49.5 38.182 49.5 34.4017 49.5H20.0017C16.2213 49.5 14.3311 49.5 12.8872 48.7643C11.6171 48.1171 10.5845 47.0845 9.93737 45.8144C9.20166 44.3705 9.20166 42.4804 9.20166 38.7V15.3C9.20166 11.5196 9.20166 9.62947 9.93737 8.18556C10.5845 6.91547 11.6171 5.88285 12.8872 5.23571C14.3311 4.5 16.2213 4.5 20.0017 4.5H34.4017C38.182 4.5 40.0722 4.5 41.5161 5.23571C42.7862 5.88285 43.8188 6.91547 44.466 8.18556C45.2017 9.62947 45.2017 11.5196 45.2017 15.3Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral01);
export default __webpack_public_path__ + "static/media/general01.92b4271da3efba8a9b98f0607ed3e680.svg";
export { ForwardRef as ReactComponent };